import { onMounted, onUnmounted, ref } from 'vue';

import { IN_BROWSER } from '@components/utils';

import type { Ref } from 'vue';

export interface IUseDomObserver {
  elements: Ref<HTMLElement[]>;
}

export function useDomObserver(dataAlertValue: string): IUseDomObserver {
  const elements = ref<HTMLElement[]>([]);

  if (!IN_BROWSER) {
    return { elements };
  }

  const updateElements = () => {
    elements.value = Array.from(document.querySelectorAll(`[data-alert=${dataAlertValue}]`));
  };

  let observer: MutationObserver;

  onMounted(() => {
    updateElements();

    observer = new MutationObserver(updateElements);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  onUnmounted(() => {
    if (observer) {
      observer.disconnect();
    }
  });

  return { elements };
}
